import RejectPaymentPlanError from './RejectPaymentPlanError';
class InvalidPaymentPlanId extends RejectPaymentPlanError {
    paymentPlanId;
    constructor(paymentPlanId, options) {
        super('Payment plan id is invalid', options);
        this.paymentPlanId = paymentPlanId;
    }
}
export default InvalidPaymentPlanId;
